import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { RentasLiquidasGravablesComponent } from '../../impuesto-renta/rentas-liquidas-gravables-modal/rentas-liquidas-gravables-modal.component';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_228';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Lista de deudas periodes anteriores sin soportes', listHelp: ['171'] }
];


const tableStructure = [
  {id: 'desc', title: 'Descripción'}, 
  {id: 'valDeuda', title: 'Valor deuda'},
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
id: number;
desc: string;
valDeuda:string;
}

@Component({
  selector: 'app-patrimonio-deudas-anteriores-modal',
  templateUrl: './patrimonio-deudas-anteriores-modal.component.html',
  styleUrls: ['./patrimonio-deudas-anteriores-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService

  ]
})
export class PatrimonioDeudasAntModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  mensajeTabla = "Agregue, edite o elimine sus deudas según su realidad económica.";
  casillaLimpiada: boolean = false;


  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dialogRef: MatDialogRef<PatrimonioDeudasAntModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
  }

  limpiarValor() {
    if (this.modelForm.valDeuda === '0' && !this.casillaLimpiada) {
      this.modelForm.valDeuda = null;
      this.casillaLimpiada = true;
    }
  }
  
  
  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valDeuda="0";

  }
  

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_271 == undefined){

      this.model.doc.cuerpo.cc_id_271 = []; 
      this.model.doc.cuerpo.cc_id_272 = []; 
      this.model.doc.cuerpo.cs_id_172 = "0";
   
    }  
  }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_271.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_271[i].v;
      this.modelForm.valDeuda=this.model.doc.cuerpo.cc_id_272[i].v;
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
    this.operacionCs172();
  }
  
  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_271[this.modelForm.id].v=this.modelForm.desc.toString();
    this.model.doc.cuerpo.cc_id_272[this.modelForm.id].v=this.modelForm.valDeuda.toString();

    this.operacionCs172();
  }
  
  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_271.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_272.push({it: i, v:this.modelForm.valDeuda.toString()});

    this.operacionCs172();
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_271.splice(index,1);
    this.model.doc.cuerpo.cc_id_272.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_271.length;i++){
      this.model.doc.cuerpo.cc_id_271[i].it=i+1;
      this.model.doc.cuerpo.cc_id_272[i].it=i+1;
    }
    this.operacionCs172();
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
        this.modelForm.valDeuda==undefined ||  this.modelForm.valDeuda=="0" 
  }

  public redondearFormData(){
    this.modelForm.valDeuda=this.dutilidades.redondearValorMoneda(this.modelForm.valDeuda.toString(),true);
  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();

  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        //this.editModeloDesdeForm();
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        //this.modelForm.id = this.dataSourceBody.length;
        this.modelForm.id = this.model.doc.cuerpo.cc_id_271.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs172();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      //console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs172();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 172:
        this.operacionCs172();
        break;
    }
    if(soloEstaCasilla)return;
 
  }

  operacionCs172(){
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeuda, suma);
    }
    this.model.doc.cuerpo.cs_id_172 = suma;

  }
 
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  


  protected controlStep(direction: DirectionType): void {
   
  }



  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs172();
    this.dialogRef.close("");
  }

  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_271 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
        this.modelForm = this.dataSourceBody[i];
        this.addToModeloDesdeForm(); 
    }
    
    this.operacionCs172();
    
    this.saveModel.emit(true);
    this.closeModal();

  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-deudas-anteriores-modal/patrimonio-deudas-anteriores-modal.component.ts